module.exports = __webpack_public_path__ + "static/media/crous-paris-300x300.fa2bde30.png";